import React, { useState } from "react";
import ActionButton from "../Button/ActionButton";
import NormalizedStackedBarChart from "../d3Charts/NormalizedStackedBarChart/NormalizedStackedBarChart";
import "./LicenseTypes.scss";
import Loader from "../Loader/Loader";
import { colorArray } from "../../utils/theme";
import AboutChartToggle from "../AboutChartToggle/AboutChartToggle";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";

const LicenseTypesInner = ({ chartData, isLoading }) => {
  const { get, set, setMultiple } = useCustomSearchParams();
  const [shortName, setShortName] = useState(get(SEARCH_PARAMS.SHORT_NAME));
  return (
    <div className="licenseTypes-wrapper">
      {/* <p className={`licenseTypes-msg-container`}>
        Graph represents the reuse license terms available in the dataset
        metadata. Hover over colored bars to see values.
      </p> */}
      <div className="mb-3">
        <AboutChartToggle
          notes="Graph represents the reuse license terms available in the dataset
        metadata. Hover over colored bars to see values."
        />
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className="licenseTypes-chart">
          <NormalizedStackedBarChart
            chartData={chartData?.data}
            chartConfig={chartData?.config}
            chartType="value"
            title={`${shortName} License Types For Submitted Datasets Tracked by CHORUS`}
            legentPosition="bottom"
            colorArray={colorArray}
          />
        </div>
      )}
    </div>
  );
};

const LicenseTypes = (props) => (
  <ErrorBoundary>
    <LicenseTypesInner {...props} />
  </ErrorBoundary>
);

// colorArray = ["#FFFFFF", "#EFF9FF", "#A8DADC", "#5FAAD7", "#F4D35E", "#F7A541","#E8623A","#C0392B","#7B1FA2","#1A0026"];
export default LicenseTypes;
